module.exports = __webpack_public_path__ + "static/media/Base.ba8dc059.png";